export enum BlogAnalyticsEnum {
  VIEW_BLOG = '[PAC WEB] Blog - Página visualizada',
  VIEW_BLOG_CATEGORY = '[PAC WEB] Blog - Clicou em "Filtrar por categoria"',
  VIEW_BLOG_POST_PAGE = '[PAC WEB] Blog - Visualizou página da postagem',
  VIEW_BLOG_EDITORIAL_TEAM = '[PAC WEB] Blog - Clicou em "Revisado pelo(a)"',

  CLICK_SUBSCRIBE = '[PAC WEB] Blog - Clicou em "Quero me inscrever"',
  CLICK_LOAD_MORE = '[PAC WEB] Blog - Clicou em "Carregar mais"',
  CLICK_VIEW_ALL_POSTS = '[PAC WEB] Blog - Clicou em "Ver todas as postagens"',
  SHARE_BLOG_POST = '[PAC WEB] Blog - Compartilhou postagem',
  CLICK_CLICK_BOARD = '[PAC WEB] Blog - Compartilhou copiar link da postagem',
}
